import { ZENDESK_RETURN_TO_LABEL } from '#constants';
import { appRoutes, isInTwoFactorAuthenticationLoginFlow } from '#services';
export const loginRoutePredicate = ({ currentUser, defaultRoute, location, }) => {
    if (!currentUser || isInTwoFactorAuthenticationLoginFlow(currentUser)) {
        return { isSuccess: true };
    }
    if (!currentUser?.emailVerified) {
        return { isSuccess: false, navigateTo: appRoutes.verifyEmail() };
    }
    const returnTo = sessionStorage.getItem(ZENDESK_RETURN_TO_LABEL);
    if (returnTo) {
        return {
            isSuccess: false,
            navigateTo: appRoutes.zendeskAuth(returnTo),
        };
    }
    const locationState = location?.state;
    if (currentUser?.pendingInvitation) {
        return {
            isSuccess: false,
            navigateTo: appRoutes.invite(),
            locationState: {
                pendingInvite: undefined,
                shouldGoToLogin: undefined,
                shouldGoToRegister: undefined,
            },
        };
    }
    if (locationState?.pendingInvite) {
        return {
            isSuccess: false,
            navigateTo: appRoutes.invite(),
            locationState: {
                shouldGoToLogin: undefined,
                shouldGoToRegister: undefined,
            },
        };
    }
    if (locationState?.navigatedFrom) {
        return {
            isSuccess: false,
            navigateTo: locationState.navigatedFrom,
        };
    }
    return {
        isSuccess: false,
        navigateTo: defaultRoute,
    };
};
